const webviewId = 'notifyView'
let timer = 0
let notifyView = null
const Notify = function({
	time = 2000,
	message = '',
	tips = '',
	type = 'error',
	currentWebview = null
}) {
	notifyView = null
	clearTimeout(timer)

	notifyView = document.getElementById(webviewId)
	if (!notifyView) {
		let $div = document.createElement('div')
		$div.innerHTML = `<div id="${webviewId}" style="background: #fff; border-radius: 5px;border:1px solid #67c23a;
						position: fixed; top: 15%; left: 50%; transform: translateX(-50%); display: none; z-index: 9999999;">
			<div style="display:flex;align-items: center;">
				<span id="status_text"></span><br>
				<span id='zhuan_tips'></span>
			</div>
		</div>`
		notifyView = $div.firstChild
		document.body.appendChild(notifyView)
	}
	console.log(type, 'type')
	let $text = document.getElementById('status_text')
	let $tips = document.getElementById('zhuan_tips')
	notifyView.style.padding = '11.5px 26.5px'
	if (type == 'success') {
		$text.style.color = '#67c23a'
		notifyView.style.border = '1px solid #67c23a'
		// notifyView.style.background = 'linear-gradient(90deg, #51CC8E 0%, #16ADA5 100%)'
	} else if (type == 'error') {
		$text.style.color = '#F31B32'
		notifyView.style.border = '1px solid #F31B32'
		// notifyView.style.background = 'linear-gradient(90deg, #F8B134 0%, #F35A6A 100%)'
	} else if (type == 'none') {
		notifyView.style.padding = '14px 26.5px'
		$text.style.color = '#FFFFFF'
	}
	notifyView.style.fontSize = '30rpx'
	$text.innerText = message
	$tips.innerText = tips
	notifyView.style.display = 'block'
	timer = setTimeout(() => {
		notifyView.style.display = 'none'
	}, time);

}

export default Notify
